@if (cartItem) {
  <div class="cart-notes" (click)="openNotesModal(cartItem)">
    <div [ngClass]="readonly ? '' : 'cart-notes__clickable'">
      @if (cartItem.note) {
        <div class="cart-notes__content">
          <span class="cart-notes__text cart-notes__text--label" >{{ 'notes.noteLabel' | cxTranslate }}</span>
          <span class="cart-notes__text">{{ cartItem.note }}</span>
        </div>
      } @else {
        @if (!readonly) {
          <div class="cart-notes__text cart-notes__text--label">
            {{ 'notes.noteAdd' | cxTranslate }}
          </div>
        }
      }
    </div>
  </div>
}
